import React from "react" 
import dayjs from "dayjs"

export default function useDataCompare(){

  function compareData(data:any, expValue:any, operator:string){
    switch(operator){
      case "mustBe":
        return {
          data,
          expValue,
          verdict:
            data === expValue
        }
  
      case "mustBeNot":
        return {
          data,
          expValue,
          verdict:
            data !== expValue
        }
  
      case "mustBeStrict":
        return {
          data,
          expValue,
          verdict:
            data === expValue
        }
  
      case "mustNotBeStrict":
        return {
          data,
          expValue,
          verdict:
            data !== expValue
        }
  
      case "mustBeGt":
        console.log(parseInt(data) > parseInt(expValue))
        return {
          data,
          expValue,
          verdict:
            parseInt(data) > parseInt(expValue)
        }
  
      case "mustBeLt":
        return {
          data,
          expValue,
          verdict:
            parseInt(data) < parseInt(expValue)
        }
  
      case "mustBeGte":
        return {
          data,
          expValue,
          verdict:
            parseInt(data) >= parseInt(expValue)
        }
  
      case "mustBeLte":
        return {
          data,
          expValue,
          verdict:
            parseInt(data) <= parseInt(expValue)
        }
  
      case "mustBeBefore":
        return {
          data,
          expValue,
          verdict:
            dayjs(data).isBefore(dayjs(expValue))
        }
  
      case "mustBeAfter":
        return {
          data,
          expValue,
          verdict:
            dayjs(data).isAfter(dayjs(expValue))
        }
  
      case "mustContain":
        return {
          data,
          expValue,
          verdict:
            data.includes(expValue)
        }
  
      case "mustNotContain":
        return {
          data,
          expValue,
          verdict:
            !data.includes(expValue)
        }

      case "mustInclude":
        return {
          data,
          expValue,
          verdict:
            expValue.split(",").includes(data?.toString())
        }
  
      case "mustNotInclude":
        return {
          data,
          expValue,
          verdict:
            !expValue.split(",").includes(data.toString())
        }
  
      case "mustExist":
        return {
          data,
          expValue,
          verdict:
            data !== null && data !== undefined && data !== "null" && data !== "undefined"
        }
  
      case "mustNotExist":
        return {
          data,
          expValue,
          verdict:
            data === null || data === undefined || data === "null" || data === "undefined"
        }
  
      case "hasObjectWhere":
        const key = expValue.split(":")[0]
        const value = expValue.split(":")[1]
        return {
          data,
          expValue,
          verdict:
            data.find( (item:any) => item[key] === value ) !== undefined && data.find( (item:any) => item[key] === value ) !== null
        }
  
      case "hasNoObjectWhere":
        const key2 = expValue.split(":")[0]
        const value2 = expValue.split(":")[1]
        return {
          data,
          expValue,
          verdict:
            data.find( (item:any) => item[key2] === value2 ) === undefined || data.find( (item:any) => item[key2] === value2 ) === null
        }
      
      default:
        return {
          data,
          expValue,
          verdict:
            false
        }
    }
  }

  return { compareData }
}